import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { IQuery, IQueryMyProducts } from "../../interfaces/IQuery";
import {
  IResponseHistoryProducts,
  IResponseMyProducts,
} from "../../interfaces/MyProducts";
import { EServiceType } from "../../interfaces/MyPlans/IMyPlans";

export const getMyProducts = async (
  { active }: IQueryMyProducts,
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();

  if (active !== EServiceType.All) params.append("active", active);

  const { data } = await api.get<IResponseMyProducts>(
    "/web/product/my-products",
    {
      signal,
      params,
    }
  );
  return data;
};

export const useMyProducts = (params: IQueryMyProducts) => {
  const { active, enabled = true } = params;

  return useQuery({
    queryKey: ["MyProducts", active],
    queryFn: ({ signal }) => getMyProducts(params, signal),
    enabled: enabled,
  });
};

export const getMyHistoryProducts = async (
  { id }: IQuery,
  signal?: AbortSignal
) => {
  let params = new URLSearchParams();

  const { data } = await api.get<IResponseHistoryProducts>(
    `/web/product/my-products/${id}/history`,
    {
      signal,
      params,
    }
  );

  return data;
};

export const useMyHistoryProducts = (params: IQuery) => {
  const { page, pageSize } = params;

  return useQuery({
    queryKey: ["MyHistoryProducts", page, pageSize],
    queryFn: ({ signal }) => getMyHistoryProducts(params, signal),
    enabled: !!params.id,
  });
};
